(() => {
	const initSlider = (section) => {
		const popularProducts = section.querySelectorAll(".popular-products");

		const forceShowControls = (carouselOrSection, paginationSelector) => {
			const arrows = carouselOrSection.querySelectorAll(
				".swiper-button-prev, .swiper-button-next"
			);
			const pagination = carouselOrSection.querySelectorAll(paginationSelector);

			const applyStyles = (elements) => {
				elements.forEach((el) => {
					if (el) {
						el.style.setProperty("display", "flex", "important");
						el.classList.remove("swiper-button-lock", "swiper-pagination-lock");
					}
				});
			};

			applyStyles(arrows);
			applyStyles(pagination);
		};

		for (const sectionItem of popularProducts) {
			const isCollectionProductsSelected =
				sectionItem.dataset.isCollectionProductsSelected;

			const alignArrowsToImageHeight = (currentSection) => {
				const firstImage = currentSection.querySelector(".media img");
				if (!firstImage) return;

				const updateArrowPosition = () => {
					requestAnimationFrame(() => {
						const imageHeight = firstImage.offsetHeight;
						if (imageHeight === 0) return;

						const arrows = currentSection.querySelectorAll(
							".swiper-button-prev, .swiper-button-next"
						);
						arrows.forEach((arrow) => {
							arrow.style.top = `${imageHeight / 2}px`;
							arrow.style.transform = `translateY(-33%)`;
						});
					});
				};

				if (firstImage.complete) {
					updateArrowPosition();
				} else {
					firstImage.addEventListener("load", updateArrowPosition, { once: true });
				}

				window.addEventListener("resize", updateArrowPosition, { passive: true });
			};

			const buildSimpleParams = (carousel, slider) => {
				const numberColumns = slider.dataset.columnsMobile || 1;
				const productCardType = slider.dataset.productCardType || "simple";

				return {
					loop: false,
					slidesPerView: productCardType === "simple" ? 2 : Number(numberColumns) || 1,
					allowTouchMove: true,
					centeredSlides: false,
					lazy: true,
					preloadImages: false,
					spaceBetween: 8,
					speed: 800,
					watchOverflow: false,
					mousewheel: { forceToAxis: true },
					navigation: {
						nextEl: carousel.querySelector(".swiper-button-next"),
						prevEl: carousel.querySelector(".swiper-button-prev"),
					},
					pagination: {
						el: carousel.querySelector(".swiper-pagination"),
						clickable: true,
					},
					on: {
						init: function () {
							this.pagination?.render?.();
							this.pagination?.update?.();
							forceShowControls(carousel, ".swiper-pagination");
						},
						slideChange: function () {
							this.pagination?.render?.();
							this.pagination?.update?.();
							forceShowControls(carousel, ".swiper-pagination");
						},
						update: function () {
							forceShowControls(carousel, ".swiper-pagination");
						},
					},
					breakpoints: {
						320: {
							slidesPerView:
								productCardType === "simple" ? 2 : Number(numberColumns),
						},
						750: {
							slidesPerView: productCardType === "simple" ? 3 : 1,
							spaceBetween: 16,
						},
						990: {
							slidesPerView: productCardType === "simple" ? 4 : 1.2,
							spaceBetween: 16,
						},
						1360: {
							slidesPerView: productCardType === "simple" ? 4 : 1.7,
							spaceBetween: 16,
						},
					},
				};
			};

			if (
				isCollectionProductsSelected === "true" ||
				isCollectionProductsSelected === true
			) {
				// Only visible panels — hidden tabs init on user click (CLS-exempt)
				const productCarousels = sectionItem.querySelectorAll(
					'[id^="product-carousel-main-"]:not([hidden])'
				);

				productCarousels.forEach((carousel) => {
					const slider = carousel.querySelector(".swiper--products");
					if (!slider) return;
					if (slider.swiper || slider.classList.contains("swiper-initialized")) {
						return;
					}

					new Swiper(slider, buildSimpleParams(carousel, slider));
					alignArrowsToImageHeight(sectionItem);
				});
			} else {
				const slider = sectionItem.querySelector(".swiper--products");
				if (!slider) continue;
				if (slider.swiper || slider.classList.contains("swiper-initialized")) {
					continue;
				}

				const productCardType = slider.dataset.productCardType || "simple";

				new Swiper(slider, {
					loop: false,
					speed: 800,
					spaceBetween: 8,
					centeredSlides: false,
					watchOverflow: false,
					slidesPerView: productCardType === "simple" ? 2 : 1,
					mousewheel: { forceToAxis: true },
					allowTouchMove: true,
					breakpoints: {
						320: {
							slidesPerView: productCardType === "simple" ? 2 : 1,
						},
						750: {
							slidesPerView: productCardType === "simple" ? 3 : 1,
							spaceBetween: 16,
						},
						990: {
							slidesPerView: productCardType === "simple" ? 4 : 1.2,
							spaceBetween: 16,
						},
						1360: {
							slidesPerView: productCardType === "simple" ? 4 : 1.7,
							spaceBetween: 16,
						},
					},
					navigation: {
						nextEl: sectionItem.querySelector(".swiper-button-next"),
						prevEl: sectionItem.querySelector(".swiper-button-prev"),
					},
					pagination: {
						el: slider.querySelector(".popular-products__pagination"),
						clickable: true,
						type: "custom",
						renderCustom: (swiper, current, total) => {
							let out = "";
							for (let i = 1; i < total + 1; i++) {
								if (i == current) {
									out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
								} else {
									out = `${out}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
								}
							}
							return out;
						},
					},
					on: {
						init: function () {
							forceShowControls(sectionItem, ".popular-products__pagination");
						},
						slideChange: function () {
							forceShowControls(sectionItem, ".popular-products__pagination");
						},
						update: function () {
							forceShowControls(sectionItem, ".popular-products__pagination");
						},
					},
				});

				alignArrowsToImageHeight(sectionItem);
			}
		}
	};

	const initSection = (section) => {
		if (!section || !section.classList.contains("popular-products-section")) return;
		if (section.dataset.ppInited === "true") return;
		section.dataset.ppInited = "true";

		// CRITICAL: init carousels ONCE.
		// Previously ResizeObserver called initSlider on every resize (image load →
		// height change → new Swiper()) which produced CLS ~0.9 on this section.
		initSlider(section);

		const resizeObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.contentRect.width <= 1100) return;
				const productItems = entry.target.querySelectorAll(
					".popular-products__item"
				);
				productItems.forEach((item) => {
					if (item.dataset.hoverBound) return;
					item.dataset.hoverBound = "true";
					item.addEventListener("mouseover", () => {
						productItems.forEach((otherItem) => {
							if (otherItem !== item) {
								otherItem.classList.add("popular-products__item--inactive");
							}
						});
					});
					item.addEventListener("mouseout", () => {
						productItems.forEach((el) => {
							el.classList.remove("popular-products__item--inactive");
						});
					});
				});
			});
		});

		resizeObserver.observe(section);
	};

	const collectionTabs = (section) => {
		if (!section || !section.classList.contains("popular-products-section")) return;
		if (section.dataset.ppTabsInited === "true") return;
		section.dataset.ppTabsInited = "true";

		const tabs = section.querySelectorAll("[data-tab-target]");
		const tabContents = section.querySelectorAll("[data-tab-content]");

		const activateTab = (tab) => {
			const target = section.querySelector(tab.dataset.tabTarget);
			if (!target) return;

			tabContents.forEach((tabContent) => {
				tabContent.classList.remove("active");
				tabContent.setAttribute("hidden", "");
			});

			tabs.forEach((t) => {
				t.classList.remove("active");
				t.setAttribute("aria-selected", "false");
				t.setAttribute("tabindex", "-1");
			});

			tab.classList.add("active");
			tab.setAttribute("aria-selected", "true");
			tab.setAttribute("tabindex", "0");
			target.classList.add("active");
			target.removeAttribute("hidden");

			// Inflate lazy <template> panels on first open (user gesture → CLS-exempt)
			const lazyTpl = target.querySelector("template[data-lazy-tab-panel]");
			if (lazyTpl) {
				target.appendChild(lazyTpl.content.cloneNode(true));
				lazyTpl.remove();
			}

			const slider = target.querySelector(".product-carousel-swiper");
			if (
				slider &&
				!slider.swiper &&
				!slider.classList.contains("swiper-initialized")
			) {
				initSlider(section);
			} else if (slider?.swiper) {
				slider.swiper.update();
				slider.swiper.pagination?.render?.();
				slider.swiper.pagination?.update?.();
			}
		};

		tabs.forEach((tab, index) => {
			tab.addEventListener("click", () => activateTab(tab));

			tab.addEventListener("keydown", (e) => {
				let newIndex = index;

				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					tab.click();
				} else if (e.key === "ArrowRight" || e.key === "ArrowDown") {
					e.preventDefault();
					newIndex = (index + 1) % tabs.length;
				} else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
					e.preventDefault();
					newIndex = (index - 1 + tabs.length) % tabs.length;
				}

				if (newIndex !== index) {
					tabs[newIndex].focus();
					tabs[newIndex].click();
				}
			});
		});
	};

	const boot = (scope = document) => {
		scope.querySelectorAll(".shopify-section").forEach((sectionEl) => {
			if (!sectionEl.querySelector(".popular-products")) return;
			initSection(sectionEl);
			collectionTabs(sectionEl);
		});
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => boot(document), {
			once: true,
		});
	} else {
		boot(document);
	}

	document.addEventListener("shopify:section:load", (event) => {
		const sectionEl = event.target;
		if (sectionEl?.dataset) {
			delete sectionEl.dataset.ppInited;
			delete sectionEl.dataset.ppTabsInited;
		}
		initSection(sectionEl);
		collectionTabs(sectionEl);
	});
})();
